<template>
  <a
      data-toggle="collapse"
      :style="styles"
      :href="'#' + href"
      role="button"
      :aria-controls="href"
  >
    <ks-text :text="text" :tag="tag" v-if="text"/>
    <ks-icon :icon="icon" v-if="icon" :abbreviated="abbreviated"/>
  </a>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  /**
   tag
   name: ks-accordion
   description: accordion card
   **/
  name: 'ks-accordion-button',
  mixins: [checkPermissions],
  computed: {
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    },
    type() {
      return this.$parent.type ? this.$parent.type : null;
    }
  },
  props: {
    /**
     attribute
     name: id
     description: id
     **/
    collapseId: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    tag: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    },
    styles: {
      type: String,
      default: ''
    },
    collapse: {
      type: Boolean,
      default: false
    },
    abbreviated: {
      type: Boolean,
      default: false
    },
  }
}
</script>
